interface CopyRightProps {
  groupId: number
}

export const CopyrightAndCompliance: React.FC<CopyRightProps> = ( {groupId} ) => {
  const currentYear = new Date().getFullYear()
  return (
    <>
      <div className="footer__bottom-panel-left">
        <p className="footer__copyright-text">
          &copy;&nbsp; Copyright Lookers Limited {currentYear}
        </p>
        <div className="compliance-statement-text">
          {groupId === 2 ? 
            <>
              <p>
                Charles Hurst is a trading name of Charles Hurst Limited which is
                an appointed representative of Lookers Motor Group Limited.  
                Lookers Motor Group Limited is authorised and regulated by 
                the Financial Conduct Authority for credit broking and 
                insurance distribution activities under reference number&nbsp;
                <a
                  rel="noopener noreferrer"
                  href="https://register.fca.org.uk/"
                  target="_blank"
                  title="Opens in a new window"
                >
                309424.
                </a>
              </p>
              <p>
                Introducing you to a number of lenders means we receive a commission. 
                Lenders pay commission at different rates either as a fixed fee or as 
                a fixed percentage of the amount you borrow. The commission that we 
                receive does not affect the amount that you pay to the lender under 
                the credit agreement. Credit subject to status.
              </p>
            </>
          : 
            <>
              <p>
                Lookers is a trading name of Lookers Motor Group Limited which is
                authorised and regulated by the Financial Conduct Authority for
                credit broking and insurance distribution activities under reference
                number&nbsp;
                <a
                  rel="noopener noreferrer"
                  href="https://register.fca.org.uk/"
                  target="_blank"
                  title="Opens in a new window"
                >
                309424.
                </a>
              </p>
              <p>
                Introducing you to a number of lenders means we receive a
                commission. Lenders pay commission at different rates either as a
                fixed fee or as a fixed percentage of the amount you borrow. The
                commission that we receive does not affect the amount that you pay
                to the lender under the credit agreement.
              </p>
            </>
          }
        </div>
      </div>
    </>
  )
}
